export default __webpack_public_path__ + "static/media/login-facebook-en.ba091f5a.png";